import { Box, Typography } from "@mui/material";
import React, { useCallback, useRef } from "react";
import avatar1 from "../assets/image/avatar1.jpeg";
import avatar2 from "../assets/image/avatar2.jpeg";
import avatar3 from "../assets/image/avatar3.jpeg";
import EyeIcon from "../assets/SVG/eyeIcon";
// import GridComponent from "./GridComponent"
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { useState, useMemo, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Them
import {
  getAdmins,
  changeStatus,
  changeStatusGroup,
  loginAdminToUser,
} from "../api/admins";
import FemaleIcon from "../assets/SVG/femaleIcon";
import MaleIcon from "../assets/SVG/maleIcon";
import AccessibilityIcon from "../assets/SVG/accessibilityIcon";
import SelectiosnFuncTable from "./accontsTable/selectiosnFuncTable";
// import { useMemo,useEffect } from "react";
// import { useEffect } from "react";
import { ModuleRegistry } from "@ag-grid-community/core";
import { ExcelExportModule } from "@ag-grid-enterprise/excel-export";
import {
  changeStatusGroupLeader,
  getAllGroups,
  getGroupAdminInfo,
  getGroupLeaderInfo,
  getGroupsUsers,
  signInGroupUser,
} from "../api/group";
import loadingImage from "../assets/image/Loading.png";
import ViewProfile from "./profile/viewProfile";
import EyeOpenIcon from "../assets/SVG/eyeOpenIcon";
import { getToken, setToken, setTokenUser } from "../api/token";
import { useNavigate } from "react-router-dom";
import TableIcon from "../assets/SVG/tableIcon";

ModuleRegistry.registerModules([ExcelExportModule]);

export default function AdminTable({
  title,
  mujahid,
  selected,
  dataGroup,
  gridRef,
}) {
  const navigate = useNavigate();
  const styleTableRow = { width: "100%", marginRight: "10px" };
  const [rowData, setRowData] = useState([]);
  const [openProfilePop, setOpenProfilePop] = useState();
  const [dataMyInfo, setDataMyInfo] = useState();
  const [image, setImage] = useState();
  const [groupInfo, setGroupInfo] = useState();

  const [selection, setSelection] = React.useState([]);
  const [loading, setLoading] = useState();

  const onBtExport = useCallback(() => {
    gridRef.current.api.exportDataAsExcel();
    console.log(gridRef.current.api);
  }, []);
  const onSelectionChanged = (e) => {
    const selectedNodes = e.api.getSelectedNodes();
    const lastSelectedNode =
      selectedNodes[0]?.selectionController?.lastSelectedNode;
    // if lastSelectedNode is missing while multi-selecting,
    // AgGrid will select from the first row
    const selectedNodeFrom = lastSelectedNode || e.api.getRenderedNodes()[0];
    const isRangeSelect = KEYBOARD_STATE.isShiftPressed;
    const difference = (arr1, arr2) => arr1.filter((x) => !arr2.includes(x));
    const newSelection = difference(selectedNodes, selection);

    if (newSelection.length > 0) {
      if (isRangeSelect) {
        const isSelectBackward =
          newSelection[0].rowIndex < selectedNodeFrom.rowIndex;

        if (isSelectBackward) {
          newSelection.reverse();
        }
      }

      newSelection.forEach((n) => updateSelection(n));
    } else {
      updateSelection(); // deselect
    }
  };
  const KEYBOARD_STATE = {
    isShiftPressed: false,
  };
  document.addEventListener("keydown", (e) => {
    KEYBOARD_STATE.isShiftPressed = e.key === "Shift";
  });
  document.addEventListener("keyup", (e) => {
    KEYBOARD_STATE.isShiftPressed = false;
  });
  // console.log(selection);
  const updateSelection = (rowNode) => {
    setSelection((selections) => {
      if (rowNode) {
        const isSelected = rowNode.isSelected();

        if (isSelected) {
          return [...selections, rowNode];
        } else {
          return selections.filter((s) => s.id !== rowNode.id);
        }
      } else {
        return selections.filter((n) => n.isSelected());
      }
    });
  };
  // Column Definitions: Defines & controls grid columns.
  const [colDefs] = useState([
    {
      field: "name",
      headerName: "نام مسئول",
      width: 200,
      headerCheckboxSelection: true,
      checkboxSelection: true,
    },
    {
      field: "sex",
      headerName: "جنسیت",
      width: 150,
      cellRenderer: (x) => {
        return x.data.sex === "MALE" ? (
          <Box display="flex" alignItems="center">
            <MaleIcon size="0.5" />
            <Typography fontFamily="Shabnam">{" " + "مرد"}</Typography>
          </Box>
        ) : (
          <Box display="flex" alignItems="center">
            <FemaleIcon size="0.5" />
            <Typography fontFamily="Shabnam">{" " + "زن"}</Typography>
          </Box>
        );
      },
    },

    {
      field: "fatherName",
      headerName: "نام پدر",
      width: 200,
    },
    {
      field: "groupName",
      headerName: "گروه",
      width: 150,
    },
    {
      field: "nid",
      headerName: "کد ملی",
      width: 200,
    },
    {
      field: "university",
      headerName: "دانشگاه",
      width: 200,
    },
    {
      field: "phone",
      headerName: "شماره تلفن",
      width: 200,
    },
    {
      field: "birthDay",
      headerName: "تاریخ تولد",
      width: 200,
    },
    {
      field: "field",
      headerName: "رشته تحصیلی",
      width: 200,
    },
    {
      field: "allergies",
      headerName: "حساسیت ها",
      width: 200,
    },
    {
      field: "abilities",
      headerName: "مهارت ها",
      width: 200,
    },
    {
      field: "diseases",
      headerName: "بیماری ها",
      width: 200,
    },
    {
      field: "",
      headerName: "اطلاعات آشنایان",
      width: 300,
      cellRenderer: (x) => {
        return (
          <>
            {x.data.nearbyPhone && x.data.nearbyRel && x.data.nearbyName && (
              <Box>{`${x.data.nearbyName} / ${x.data.nearbyRel} / ${x.data.nearbyPhone}`}</Box>
            )}
          </>
        );
      },
    },
    {
      field: "bloodType",
      headerName: "گروه خونی",
      width: 150,
      cellRenderer: (x) => {
        return (
          <>
            {x.value === "A_PLUS"
              ? "+A"
              : x.value === "A_MINUS"
              ? "-A"
              : x.value === "B_PLUS"
              ? "+B"
              : x.value === "B_MINUS"
              ? "-B"
              : x.value === "AB_MINUS"
              ? "-AB"
              : x.value === "AB_PLUS"
              ? "+AB"
              : x.value === "O_PLUS"
              ? "+O"
              : "-O"}
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "عملیات",
      width: 200,
      cellRenderer: (x) => {
        return (
          <>
            <Box
              bgcolor={x.value === "PENDING" ? "#682C54" : "#F05542"}
              gap="9px"
              width="fit-content"
              px="9px"
              display="flex"
              alignItems="center"
              borderRadius="9px"
              sx={{ cursor: "pointer" }}
              onClick={() => {
                if (selected === 4) {
                  changeStatusGroupLeader(
                    x.data.id,
                    x.value === "PENDING" ? "ACTIVE" : "PENDING"
                  )
                    .then(() => {
                      setRowData((data) => {
                        return data.map((z) =>
                          z.id === x.data.id
                            ? {
                                ...z,
                                status:
                                  x.value === "PENDING" ? "ACTIVE" : "PENDING",
                              }
                            : { ...z }
                        );
                      });
                    })
                    .catch(() => {});
                } else {
                  changeStatus(
                    x.data.id,
                    x.value === "PENDING" ? "ACTIVE" : "PENDING"
                  )
                    .then(() => {
                      setRowData((data) => {
                        return data.map((z) =>
                          z.id === x.data.id
                            ? {
                                ...z,
                                status:
                                  x.value === "PENDING" ? "ACTIVE" : "PENDING",
                              }
                            : { ...z }
                        );
                      });
                    })
                    .catch(() => {});
                }
              }}
            >
              <AccessibilityIcon color="white" size="0.7" />
              <Typography fontFamily="Shabnam" color="white" fontSize="13px">
                {x.value === "PENDING" ? "اجازه دسترسی" : "لغو دسترسی"}
              </Typography>
            </Box>
            <Box
              onClick={() => {
                if (selected === 4) {
                  getGroupLeaderInfo(x.data.id)
                    .then((z) => {
                      setDataMyInfo(z);
                      setOpenProfilePop(true);
                    })
                    .catch(() => {});
                  setGroupInfo(false);
                } else {
                  getGroupAdminInfo(x.data.id)
                    .then((z) => {
                      setDataMyInfo(z);
                      setOpenProfilePop(true);
                    })
                    .catch(() => {});
                  setGroupInfo(false);
                }
              }}
              display="flex"
              justifyContent={"center"}
              p="2px"
              borderRadius={"8px"}
              sx={{
                mr: "5px",
                bgcolor: "#EEEEEE",
                transition: "0.3s all",
                cursor: "pointer",
                ":hover": { bgcolor: "#A2E5C5" },
              }}
            >
              <EyeOpenIcon />
            </Box>
            <Box
              onClick={() => {
                if (selected === 4) {
                  signInGroupUser({
                    nid: x.data.nid,
                  })
                    .then((y) => {
                      setTokenUser(getToken());
                      setToken(y);
                      // setTimeout(() => {
                      navigate("/");
                      window.location.reload();
                      // }, 3000);
                    })
                    .catch(() => {});
                } else {
                  loginAdminToUser({
                    nid: x.data.nid,
                  })
                    .then((y) => {
                      setTokenUser(getToken());
                      setToken(y);
                      // setTimeout(() => {
                      navigate("/");
                      window.location.reload();
                      // }, 3000);
                    })
                    .catch(() => {});
                }
              }}
              display="flex"
              justifyContent={"center"}
              px="5px"
              borderRadius={"8px"}
              sx={{
                mr: "5px",
                bgcolor: "#EEEEEE",
                transition: "0.3s all",
                cursor: "pointer",
                p: "6px",
                ":hover": { bgcolor: "#A2E5C5" },
              }}
            >
              <TableIcon />
            </Box>
          </>
        );
      },
    },
  ]);
  const [colDefsGroups] = useState([
    {
      field: "name",
      headerName: "نام و نام خانوادگی",
      width: 200,
      headerCheckboxSelection: true,
      checkboxSelection: true,
      // cellRenderer: (x) => {
      //   return x.data.user.sex === "male" ? (
      //     <Box display="flex" alignItems="center">
      //       <MaleIcon size="0.5" />
      //       <Typography>{" " + x.value}</Typography>
      //     </Box>
      //   ) : (
      //     <Box display="flex" alignItems="center">
      //       <FemaleIcon size="0.5" />
      //       <Typography>{" " + x.value}</Typography>
      //     </Box>
      //   );
      // },
    },
    {
      field: "groupName",
      headerName: "نام گروه",
      width: 130,
    },

    {
      field: "lodgment",
      headerName: "محل استقرار گروه",
      width: 200,
      cellRenderer: (x) => {
        return (
          <>
            {x.value === "mosque"
              ? "مسجد"
              : x.value === "OFFICE"
              ? "دفتر خصوصی"
              : x.value === "UNIVERSITY"
              ? "دانشگاه"
              : x.value === "BASIJ"
              ? "دفتر بسیج"
              : "مسجد"}
          </>
        );
      },
    },
    {
      field: "phone",
      headerName: "شماره تلفن مسئول",
      width: 170,
    },
    {
      field: "tel",
      headerName: "شماره تلفن ثابت",
      width: 150,
    },
    {
      field: "",
      headerName: "عملیات",
      width: 300,
      cellRenderer: (x) => {
        return (
          <>
            <Box
              bgcolor={
                x.data.status === "PENDING" || x.data.status === "PENDING"
                  ? "#682C54"
                  : "#F05542"
              }
              gap="9px"
              width="fit-content"
              px="9px"
              display="flex"
              alignItems="center"
              borderRadius="9px"
              sx={{ cursor: "pointer" }}
              onClick={() => {
                changeStatus(
                  x.data.id,
                  x.data.status === "PENDING" ? "ACTIVE" : "PENDING"
                )
                  .then(() => {
                    setRowData((data) => {
                      return data.map((z) =>
                        z.id === x.data.id
                          ? {
                              ...z,
                              status:
                                x.data.status === "PENDING"
                                  ? "ACTIVE"
                                  : "PENDING",
                            }
                          : { ...z }
                      );
                    });
                  })
                  .catch(() => {});
              }}
            >
              <AccessibilityIcon color="white" size="0.7" />
              <Typography fontFamily="Shabnam" color="white" fontSize="13px">
                {x.data.status === "pending" || x.data.status === "PENDING"
                  ? "اجازه دسترسی"
                  : "لغو دسترسی"}
              </Typography>
            </Box>
            {x.data.status === "ACTIVE" && (
              <Box
                bgcolor={
                  x.data.groupStatus === "PENDING" ||
                  x.data.groupStatus === "PENDING"
                    ? "green"
                    : "red"
                }
                gap="9px"
                width="fit-content"
                px="9px"
                py="2px"
                mr="5px"
                display="flex"
                alignItems="center"
                borderRadius="9px"
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  changeStatusGroup(x.data.id)
                    .then(() => {
                      setRowData((data) => {
                        return data.map((z) =>
                          z.id === x.data.id
                            ? {
                                ...z,
                                groupStatus:
                                  x.data.groupStatus === "PENDING"
                                    ? "ACTIVE"
                                    : "PENDING",
                              }
                            : { ...z }
                        );
                      });
                    })
                    .catch(() => {});
                }}
              >
                {/* <AccessibilityIcon color="white" size="0.7" /> */}
                <Typography fontFamily="Shabnam" color="white" fontSize="14px">
                  {x.data.groupStatus === "pending" ||
                  x.data.groupStatus === "PENDING"
                    ? "تایید گروه"
                    : "رد گروه"}
                </Typography>
              </Box>
            )}
            <Box
              onClick={() => {
                getGroupAdminInfo(x.data.id)
                  .then((z) => {
                    setDataMyInfo(z);
                    setOpenProfilePop(true);
                  })
                  .catch(() => {});
                setGroupInfo(true);
              }}
              display="flex"
              justifyContent={"center"}
              p="2px"
              borderRadius={"8px"}
              sx={{
                mr: "5px",
                bgcolor: "#EEEEEE",
                transition: "0.3s all",
                cursor: "pointer",
                ":hover": { bgcolor: "#A2E5C5" },
              }}
            >
              <EyeOpenIcon />
            </Box>
            <Box
              onClick={() => {
                loginAdminToUser({
                  nid: x.data.nid,
                })
                  .then((y) => {
                    setTokenUser(getToken());
                    setToken(y);
                    // setTimeout(() => {
                    navigate("/");
                    window.location.reload();
                    // }, 3000);
                  })
                  .catch(() => {});
              }}
              display="flex"
              justifyContent={"center"}
              px="5px"
              borderRadius={"8px"}
              sx={{
                mr: "5px",
                bgcolor: "#EEEEEE",
                transition: "0.3s all",
                cursor: "pointer",
                p: "6px",
                ":hover": { bgcolor: "#A2E5C5" },
              }}
            >
              <TableIcon />
            </Box>
          </>
        );
      },
    },
  ]);
  useEffect(() => {
    if (selected === 1) {
      setLoading(true);
      getAdmins("?justGroupRequests=false")
        .then((x) => {
          setRowData(x);
          setLoading(false);
        })
        .catch((z) => console.log(z));
    }
    if (selected === 2) {
      setLoading(true);
      getAdmins(`?justGroupRequests=true`)
        .then((x) => {
          setLoading(false);
          setRowData(x);
        })
        .catch(() => {});
    }
    if (selected === 3) {
      setLoading(true);
      getAdmins(`?groupName=${dataGroup.name}`)
        .then((x) => {
          setRowData(x);
          setLoading(false);
        })
        .catch((z) => console.log(z));
    }
    if (selected === 4) {
      setLoading(true);
      getGroupsUsers()
        .then((x) => {
          setRowData(x);
          setLoading(false);
        })
        .catch((z) => console.log(z));
    }
  }, [selected]);
  useEffect(() => {
    if (!rowData) {
      setLoading(true);
    }
  });

  const defaultColDef = useMemo(() => ({
    filter: true,
    editable: false,
  }));
  const localeText = {
    page: "صفحه",
    to: "تا",
    of: "از",
    next: "بعدی",
    previous: "قبلی",
    last: "آخرین",
    first: "اولین",
    loadingOoo: "در حال بارگذاری...",
    noRowsToShow: "داده‌ای برای نمایش وجود ندارد",
    pageSizeSelectorLabel: "تعداد سطر در هر صفحه", // ترجمه Page Size
    rowGroupColumnsEmptyMessage: "برای گروه‌بندی، ستون را اینجا بکشید",
    // سایر متون مورد نیاز...
  };
  return (
    <>
      <ViewProfile
        view
        groupInfo={groupInfo}
        image={image}
        setImage={setImage}
        setDataMyInfo={setDataMyInfo}
        dataMyInfo={dataMyInfo}
        setShow={setOpenProfilePop}
        show={openProfilePop}
      />
      <div
        className="ag-theme-quartz"
        style={{
          height: selection.length >= 1 ? "calc( 60vh - 60px )" : "62vh",
          position: "relative",
        }}
      >
        {loading && (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="100%"
            height="60vh"
            bgcolor="white"
            position="absolute"
            zIndex="20"
            top="50px"
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              width="100%"
              height="60vh"
              bgcolor="#00000080"
            >
              <img className="imageLoading" src={loadingImage} />
            </Box>
          </Box>
        )}
        <AgGridReact
          pagination={true}
          ref={gridRef}
          rowHeight={60}
          enableRtl={true}
          rowData={rowData}
          localeText={localeText}
          columnDefs={selected === 2 ? colDefsGroups : colDefs}
          defaultColDef={defaultColDef}
          rowSelection={"multiple"}
          suppressRowClickSelection={true}
          onSelectionChanged={onSelectionChanged}
          // onSelectionChanged={(event) => console.log(event)}
          // onRowSelected={(e)=>console.log(e)}
          onCellValueChanged={(event) =>
            console.log(`New Cell Value: ${event.value}`)
          }
        />
        {selection.length >= 1 && (
          <SelectiosnFuncTable
            selected={selected}
            onBtExport={onBtExport}
            rowData={rowData}
            setRowData={setRowData}
            setData={setSelection}
            data={selection}
            count={selection.length}
            setDataMyInfo={setDataMyInfo}
            setOpenProfilePop={setOpenProfilePop}
            setGroupInfo={setGroupInfo}
          />
        )}
      </div>
    </>
  );
}
